// toast.js
import Vue from "vue"; // 引入 Vue 是因为要用到 Vue.extend() 这个方法
import index from "./index.vue"; // 引入组件

let ToastConstructor = Vue.extend(index); //创建构造器
let instance;
const Toast = function (options = {}) {
  instance = new ToastConstructor({
    data: options
  }); //创建实例
  document.body.appendChild(instance.$mount().$el); // 将元素挂载到 body 下
};
export default Toast;
